<template>
  <SlideSidebarContainer>
    <span slot="title">Estudantes #cyberclass</span>
    <span slot="subtitle">destaques por empenho com o conhecimento</span>

    <UserRankIndex v-slot="{ users }">
      <UserRankItem
        v-for="user in users"
        :key="user.id"
        :user="user"
        class="mb-3"
      />
    </UserRankIndex>
  </SlideSidebarContainer>
</template>

<script>
  import SlideSidebarContainer from '@/components/layout/sidebars/SlideSidebarContainer'
  import UserRankIndex from '@/components/user/rank/UserRankIndex'
  import UserRankItem from '@/components/user/rank/UserRankItem'
  
  export default {
    components: {
      SlideSidebarContainer,
      UserRankIndex,
      UserRankItem,
    },
  }
</script>
